import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8b600a94"), n = n(), _popScopeId(), n);
const _hoisted_1 = { id: "world-overlay-container" };
const _hoisted_2 = _withScopeId(() => _createElementVNode("div", { class: "world-grid margin-right-scroll" }, [
    _createElementVNode("p", null, "ICAO"),
    _createElementVNode("p", null, "Arrivals"),
    _createElementVNode("p", null, "Ground"),
    _createElementVNode("p", null, "Tower"),
    _createElementVNode("p", null, "Appr."),
    _createElementVNode("p", null, "Dep."),
    _createElementVNode("p", null, "ATIS")
], -1));
const _hoisted_3 = _withScopeId(() => _createElementVNode("hr", { class: "dashed" }, null, -1));
const _hoisted_4 = {
    key: 0,
    class: "full-parent absolute grid-center"
};
const _hoisted_5 = { id: "world-main-container" };
const _hoisted_6 = { class: "world-grid" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoadingIndicator = _resolveComponent("LoadingIndicator");
    const _component_Dot = _resolveComponent("Dot");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createVNode(_Transition, { name: "load" }, {
            default: _withCtx(() => [
                (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_LoadingIndicator, { class: "shadow" })
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
            _createVNode(_TransitionGroup, {
                name: "airport",
                tag: "div",
                class: "flex-column-gap-small"
            }, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.airports, (airport) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: airport.icao
                        }, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("p", null, _toDisplayString(airport.icao), 1),
                                _createElementVNode("p", null, _toDisplayString(airport.arrivalsCount), 1),
                                _createVNode(_component_Dot, {
                                    active: airport.hasGround
                                }, null, 8, ["active"]),
                                _createVNode(_component_Dot, {
                                    active: airport.hasTower
                                }, null, 8, ["active"]),
                                _createVNode(_component_Dot, {
                                    active: airport.hasApproach
                                }, null, 8, ["active"]),
                                _createVNode(_component_Dot, {
                                    active: airport.hasDeparture
                                }, null, 8, ["active"]),
                                _createVNode(_component_Dot, {
                                    active: airport.hasAtis
                                }, null, 8, ["active"])
                            ])
                        ]));
                    }), 128))
                ]),
                _: 1
            })
        ])
    ]));
}
